var _ellipse, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 15.5,
    rx: 14.5,
    ry: 14.5,
    fill: "#F1EBE7",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.5C1.5 7.76801 7.76801 1.5 15.5 1.5C23.232 1.5 29.5 7.76801 29.5 15.5C29.5 23.232 23.232 29.5 15.5 29.5C7.76801 29.5 1.5 23.232 1.5 15.5Z",
    stroke: "#363636",
    strokeOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6464 15.6464C10.4512 15.8417 10.4512 16.1583 10.6464 16.3536L13.8284 19.5355C14.0237 19.7308 14.3403 19.7308 14.5355 19.5355C14.7308 19.3403 14.7308 19.0237 14.5355 18.8284L11.7071 16L14.5355 13.1716C14.7308 12.9763 14.7308 12.6597 14.5355 12.4645C14.3403 12.2692 14.0237 12.2692 13.8284 12.4645L10.6464 15.6464ZM22 15.5L11 15.5V16.5L22 16.5V15.5Z",
    fill: "#363636",
    fillOpacity: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.af585c34f4a174b0ecb49bcf1c89641b.svg";
export { ForwardRef as ReactComponent };